import { Engine, Scene } from "@babylonjs/core"
import { Cameras } from "./Cameras"
import { Gui } from "./Gui"
import { MazeCigs } from "./MazeCigs"
import { Coor } from "./MazeGrid"
import { MazeStages } from "./MazeStages"
import { MazeWalls } from "./MazeWalls"

export class MazeStore {

    private static innerInstance: MazeStore

    canvas: HTMLCanvasElement
    engine: Engine
    width: number
    height: number

    scene: Scene
    cameras: Cameras
    mazeWalls: MazeWalls
    mazeCigs: MazeCigs
    mazePathfinder: (from: Coor, to: Coor) => Array<Coor>
    stages: MazeStages
    gui: Gui

    // Values set by the game
    userStartedMaze = false
    userDoneWithMaze = false
    teenCanFinishOneMinute: boolean
    youCanFinishTwoMinutes: boolean

    static get instance() {
        return this.innerInstance || (this.innerInstance = new this())
    }

    static newInstance() {
        return this.innerInstance = new this()
    }
}
